/*
 * @Descripttion: 人群抽取
 * @Author: yang chenglin
 */

import { lazy } from 'ice';
import UUID from '@/utils/UUID';
import iconImage from '@/assets/images/CanvasImages/extraction.svg';
import Form from './Form';
import Info from './Info';

export default {
  info: {
    icon: 'icon-iconlujingyunsuan-03',
    // iconText: '&#xe668;',
    iconText: iconImage,
    name: 'CROWD_EXTRACT',
    label: '人群抽取',
    //输入类型： 0-无 1-人群包 2-人群包列表
    inputType: 2, //输入人群包列表
    minInputCount: 1, //最小输入数量1
    maxInputCount: 1, //最大输入数量1
    //输出类型： 0-可选 1-人群包 2-人群包列表
    outputType: 1, //输出人群包
    minOutputCount: 1, //最小输出数量1
    maxOutputCount: 99, //最大输出数量99
    desc: '从【人群操作各个节点】中抽取部分人群'
  },
  data: () => ({
    name: `人群抽取 ${UUID.getNowTime()}`,
    preActName: '', // 上级节点名称
    extractType: '', // 短信节点：1-全部，2-成功，3-失败；拆分去重排除交集节点：直接是人群包名
    remark: '',
    preResourceType: '', // 前置节点类型：MARKETING_SMS-发短信，CROWD_SPLIT-拆分，CROWD_DIFFERENCES-去重，MARKETING_MSG_BOX-优惠促销消息盒子 CROWD_DIFFERENCE-排除 CROWD_UNION_2-N交1 CROWD_INTERSECTION_2-N交1
  }),

  validators: {
    name: (val, allNodeData = [], currentNode = {}, getAllNodes = []) => new Promise((resolve, reject) => {
      //allNodeData是点击menu上各种操作的按钮操作之后的节点数据，getAllNodes是从画布上直接得到的所有现有节点的id，
      //当通过按钮删除节点的时候走前者，allNodeData是删除后的数据，但当不通过删除组件按钮删除节点，而是通过键盘Del键时，
      //是直接走的画布上的键盘监听方法，改变不了allNodeData，因此此处判断节点名称是否重复的时候，要计算一下
      //例如：画布上现有节点id[1,2,3]，键盘Del键删掉3之后，allNodeData仍然是[1,2,3]，而getAllNodes是[1,2]
      allNodeData.forEach((item, index) => {
        if(!getAllNodes.includes(item.nodeId)){
          allNodeData.splice(index, 1)
        }
      })
      try {
        if (val === '') {
          reject(new Error('节点名称不能为空'));
        } else if (allNodeData.filter((item) => { if (item.data.name === val && item.nodeId !== currentNode.nodeId) return item }).length >= 1) {
          reject(new Error('节点名称不能与其他节点重复'));
        } else {
          resolve();
        }
      } catch (error) {
        throw error;
      }
    }),
    preActName: (val, prevNodes = []) => new Promise((resolve, reject) => {
      try {
        // if (val === '') {
        //   if (prevNodes.length) { // 最终保存时调用的各节点校验，不会传prevNodes数据，所以不能全部都校验这个参数
        //     reject(new Error('请确认上级节点信息是否完善'));
        //   } else {
        //     reject(new Error('请确认是否连接上级节点'));
        //   }
        // } else {
        //   resolve();
        // }
        resolve();
      } catch (error) {
        throw error;
      }
    }),
    extractType: (val) => new Promise((resolve, reject) => {
      try {
        if (val === '') {
          reject(new Error('人群抽取类型不能为空'));
        } else {
          resolve();
        }
      } catch (error) {
        throw error;
      }
    }),
    // remark: (val) => new Promise((resolve, reject) => {
    //   try {
    //     if (val === '') {
    //       reject(new Error('备注不能为空'));
    //     } else {
    //       resolve();
    //     }
    //   } catch (error) {
    //     throw error;
    //   }
    // }),
  } ,
  components: {
    // Form: lazy(() => import('./Form')),
    // Info: lazy(() => import('./Info')),
    Form: Form,
    Info: Info,
  }
}
